import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import {
  MediaIntegrationLogLookupRequest,
  MediaIntegrationLogLookupResponse
} from '../models/media-integration-log.models';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MediaIntegrationLogService {
  constructor(private api: ApiService) {}
  private baseUrl = environment.apiUrl;

  lookup(request: MediaIntegrationLogLookupRequest): Observable<MediaIntegrationLogLookupResponse> {
    return this.api.post<MediaIntegrationLogLookupResponse>(
      `${this.baseUrl}/MediaIntegrationLog/Lookup`,
      {
        Page: request.Page,
        PageSize: request.PageSize,
        SearchText: request.SearchText,
        ShowErrorsOnly: request.ShowErrorsOnly
      }
    );
  }
}